import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["metadata"];
export var dataLayerPushWithQueue = function dataLayerPushWithQueue(data) {
  var _window, _window$dataLayer;
  var metadata = data.metadata,
    toSend = _objectWithoutProperties(data, _excluded);
  (_window = window) == null ? void 0 : (_window$dataLayer = _window.dataLayer) == null ? void 0 : _window$dataLayer.push(toSend);
};